import Auth from './auth'
import Vue from 'vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import App from './App'
import Paginate from 'vuejs-paginate'
import messagesJa from './strings/validator/messages/ja.js'
import VeeValidate from 'vee-validate'

import './styles/settings.scss'

Vue.component('paginate', Paginate)
Vue.use(VeeValidate, {
  locale: 'ja',
  dictionary: {
    ja: { custom: messagesJa }
  }
})
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.use(Auth)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  created: function () {
    window.Vue = this
  },
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js